<script setup lang="ts">
import AppNotification from '@/components/AppNotification.vue';
import UIVersionAlert from '@/components/common/UIVersionAlert.vue';
import SmartGlobalLoader from '@/components/loaders/SmartGlobalLoader.vue';
import { brandConfig } from '@/brand';
</script>

<template>
  <template v-if="brandConfig.brand === 'kk'">
    <UIVersionAlert />
  </template>
  <SmartGlobalLoader />
  <v-app>
    <router-view />
  </v-app>
  <notifications
    :class="$style.notifications"
    reverse
    group="defaultNotificationHolder"
    position="bottom right"
  >
    <template #body="props">
      <AppNotification v-bind="{ ...props, class: '' }" />
    </template>
  </notifications>
</template>

<!-- prettier-ignore -->
<style module lang="scss">
@use '@/styles/colors';
@use '@/styles/variables';

.notifications {
  margin-bottom: variables.$tableFooterHeight;
}
</style>
